import orderBy from 'lodash/orderBy';

import { IEquipmentTestDrive } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentTestDrive.dto';

import format from '@r1-frontend/ui-react/components/costs/Cost/format';
import { IOptionVariant } from '@r1-frontend/ui-react/components/OptionList';
import { ICustomOptions } from '@r1-frontend/ui-react/components/OptionList/CustomOptionList';
import { RubleSymbol } from '@r1-frontend/ui-react/tokens/symbols';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { dayPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { EPriceTypes } from '@r1-frontend/shared/types/EPriceTypes';

import { EPriceOperationTypes } from '~/src/entities/price';
import type { PriceOptionProps } from '~/src/features/work-in-home-ab/types';

type TTestDriveOption = (ICustomOptions & { description: string }) | undefined

const day = getPluralize(dayPluralize);

export const getTestDriveOptions = (equipmentTestDrive: IEquipmentTestDrive | undefined, priceOptions: PriceOptionProps[]): TTestDriveOption => {
    if (!equipmentTestDrive) {
        return;
    }

    const { duration, priceDuring, pricesAfter } = equipmentTestDrive;

    const variants: IOptionVariant[] = orderBy(pricesAfter, ['type', 'duration'], ['desc', 'desc'])
        .map(variant => {
            const { id, type, duration: variantDuration, value } = variant;

            const isLeasing = type === EPriceTypes.Leasing;

            const indexOfUniqueTestDriveVariant = priceOptions.findIndex(option => option.id === id);

            if (indexOfUniqueTestDriveVariant < 0) {
                priceOptions.push({
                    id,
                    label: isLeasing ? `Рассрочка на ${variantDuration} мес.` : 'Полная стоимость',
                    operType: variantDuration > 0 ? EPriceOperationTypes.Leasing : EPriceOperationTypes.Possess,
                    price: value,
                    type,
                    value: variantDuration,
                });
            }

            return {
                id: variantDuration,
                label: isLeasing ? `Рассрочка на ${variantDuration} мес.` : 'Полная стоимость',
                value,
                valueStr: format(value, isLeasing ? { monthly: true } : undefined),
            };
        });

    return {
        id: EPriceOperationTypes.TestDrive,
        value: `${priceDuring} ${RubleSymbol} на ${duration} ${day(duration)}`,
        description: `Тестируйте оборудование ${duration} ${day(duration)}. Условия покупки оборудования после окончания тест-драйва:`,
        variants,
    };
};
